module.exports = __webpack_public_path__ + "static/media/fire_bg.1810b65e.jpg";